import { createApiMutation } from "../../generated-factory";
import { apiClientManager } from "@app/stores/api-manager";
import type { UseDeleteActivityRequest, UseDeleteActivityData, UseDeleteActivityTypeRequest, UseDeleteActivityTypeData, UseDeleteGroupRequest, UseDeleteGroupData, UseDeleteGroupMemberPetRequest, UseDeleteGroupMemberPetData, UseDeleteGroupScheduleRequest, UseDeleteGroupScheduleData, UseDeleteImage1Request, UseDeleteImage1Data, UseDeleteRecurringPatternRequest, UseDeleteRecurringPatternData, UseRemoveGroupMemberRequest, UseRemoveGroupMemberData } from "@api/@types/group";

export const useDeleteActivity = createApiMutation<UseDeleteActivityData, UseDeleteActivityRequest>({
  mutationFn: (req) => apiClientManager.apis.group.deleteActivity(req as UseDeleteActivityRequest),
});

export const useDeleteActivityType = createApiMutation<UseDeleteActivityTypeData, UseDeleteActivityTypeRequest>({
  mutationFn: (req) => apiClientManager.apis.group.deleteActivityType(req as UseDeleteActivityTypeRequest),
});

export const useDeleteGroup = createApiMutation<UseDeleteGroupData, UseDeleteGroupRequest>({
  mutationFn: (req) => apiClientManager.apis.group.deleteGroup(req as UseDeleteGroupRequest),
});

export const useDeleteGroupMemberPet = createApiMutation<UseDeleteGroupMemberPetData, UseDeleteGroupMemberPetRequest>({
  mutationFn: (req) => apiClientManager.apis.group.deleteGroupMemberPet(req as UseDeleteGroupMemberPetRequest),
});

export const useDeleteGroupSchedule = createApiMutation<UseDeleteGroupScheduleData, UseDeleteGroupScheduleRequest>({
  mutationFn: (req) => apiClientManager.apis.group.deleteGroupSchedule(req as UseDeleteGroupScheduleRequest),
});

export const useDeleteImage1 = createApiMutation<UseDeleteImage1Data, UseDeleteImage1Request>({
  mutationFn: (req) => apiClientManager.apis.group.deleteImage1(req as UseDeleteImage1Request),
});

export const useDeleteRecurringPattern = createApiMutation<UseDeleteRecurringPatternData, UseDeleteRecurringPatternRequest>({
  mutationFn: (req) => apiClientManager.apis.group.deleteRecurringPattern(req as UseDeleteRecurringPatternRequest),
});

export const useRemoveGroupMember = createApiMutation<UseRemoveGroupMemberData, UseRemoveGroupMemberRequest>({
  mutationFn: (req) => apiClientManager.apis.group.removeGroupMember(req as UseRemoveGroupMemberRequest),
});

export type { UseDeleteActivityRequest, UseDeleteActivityData, UseDeleteActivityTypeRequest, UseDeleteActivityTypeData, UseDeleteGroupRequest, UseDeleteGroupData, UseDeleteGroupMemberPetRequest, UseDeleteGroupMemberPetData, UseDeleteGroupScheduleRequest, UseDeleteGroupScheduleData, UseDeleteImage1Request, UseDeleteImage1Data, UseDeleteRecurringPatternRequest, UseDeleteRecurringPatternData, UseRemoveGroupMemberRequest, UseRemoveGroupMemberData } from "@api/@types/group";
